import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import {
  CreateMaintenanceInput,
  ListMaintenanceParams,
  MaintenanceWindow,
  UpdateMaintenanceInput,
} from './maintenance-types';

const KEYS = {
  all: ['maintenance'] as const,
  list: (params?: ListMaintenanceParams) =>
    [...KEYS.all, 'list', params?.game_id ?? 'all', params?.platform ?? 'all'] as const,
};

export function useMaintenance(params?: ListMaintenanceParams) {
  return useQuery({
    queryKey: KEYS.list(params),
    queryFn: async () => {
      const r = await apiClient.get<MaintenanceWindow[]>('/admin/maintenance', {
        params: {
          ...(params?.game_id ? { game_id: params.game_id } : {}),
          ...(params?.platform ? { platform: params.platform } : {}),
        },
      });
      return r.data;
    },
  });
}

export function useCreateMaintenance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateMaintenanceInput) =>
      apiClient.post<MaintenanceWindow>('/admin/maintenance', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

export function useUpdateMaintenance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateMaintenanceInput }) =>
      apiClient.patch<MaintenanceWindow>(`/admin/maintenance/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

export function useDeleteMaintenance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/admin/maintenance/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}
